/**
 * COMPOSER TEXT BEHAVIOUR — the two things a text box in a chat has to do that a textarea does not.
 *
 * Both are about not making the person do bookkeeping the editor can do: growing to fit what they
 * are writing, and continuing a list they have started. Kept out of the view because they are pure
 * functions of text and a caret, which means they can be tested without a DOM — and because the
 * composer exists twice (the opening one and the mid-conversation dock) and these must not drift.
 */
const BULLET = /^(\s*)([-*+])\s+(.*)$/;
const ORDERED = /^(\s*)(\d+)([.)])\s+(.*)$/;
const TODO = /^(\s*)([-*+])\s+\[[ xX]\]\s+(.*)$/;
/**
 * Is the caret on a list item, and what should the next line start with?
 *
 * Ordered lists increment; bullets and checkboxes repeat. An EMPTY item means the person pressed
 * Enter on a bullet they never filled in, which everywhere else in software means "I am done with
 * this list" — so it reports `empty` and the caller clears the marker instead of adding another.
 */
export function listMarkerAt(text, caret) {
    const lineStart = text.lastIndexOf('\n', Math.max(0, caret - 1)) + 1;
    const lineEndRaw = text.indexOf('\n', caret);
    const lineEnd = lineEndRaw === -1 ? text.length : lineEndRaw;
    const line = text.slice(lineStart, lineEnd);
    const todo = TODO.exec(line);
    if (todo) {
        return { indent: todo[1], next: `${todo[2]} [ ] `, empty: todo[3].trim() === '', lineStart, lineEnd };
    }
    const ord = ORDERED.exec(line);
    if (ord) {
        return { indent: ord[1], next: `${Number(ord[2]) + 1}${ord[3]} `, empty: ord[4].trim() === '', lineStart, lineEnd };
    }
    const bul = BULLET.exec(line);
    if (bul) {
        return { indent: bul[1], next: `${bul[2]} `, empty: bul[3].trim() === '', lineStart, lineEnd };
    }
    return null;
}
/**
 * Continue the list, or end it.
 *
 * Ending REPLACES the empty item rather than leaving it behind — a dangling "- " is a line the
 * person would have to delete themselves, which is the bookkeeping this exists to remove.
 */
export function continueList(text, caret, m) {
    if (m.empty) {
        const before = text.slice(0, m.lineStart);
        const after = text.slice(m.lineEnd);
        return { text: before + after, caret: m.lineStart };
    }
    const prefix = `\n${m.indent}${m.next}`;
    return { text: text.slice(0, caret) + prefix + text.slice(caret), caret: caret + prefix.length };
}
//# sourceMappingURL=composer-text.js.map